export const ASSET_LIBERARY_API_ROUTES = {
  GET_ASSET_LIBERARY: "/admin/asset-liberary",
  GET_ASSET_LIBERARY_BY_ID: "admin/asset-liberary/:id",
  CREATE_ASSET_LIBERARY: "/admin/asset-liberary",
  UPDATE_ASSET_LIBERARY: "/admin/asset-liberary/:id",
  DELETE_ASSET_LIBERARY: "/admin/asset-liberary/:id",
};
